<template>
  <component
    :is="cfgs.tag ? cfgs.tag : 'h1'"
    :class="getClasses"
  >
    <span v-html="sanitizedContent" />
  </component>
</template>

<script setup lang="ts">
import type { IBlockDefaultProps } from '#sitis/internal/models/common';
import { computed } from '#imports';

type cfgsHasContainer = 0 | 1;

type cfgsSize = 'uk-h2' | 'uk-h1' | 'uk-h3' | 'uk-h4' | 'uk-h5' | '';

type cfgsTag = null | 'h2' | 'h3' | 'h4' | 'h5' | 'div';

type cfgsStyle = 'uk-heading-primary' |
	'uk-text-center' |
	'uk-heading-divider' |
	'uk-heading-bullet' |
	'uk-heading-line-left' |
	'uk-heading-line-center' |
	'uk-heading-line-right' | '';

interface IHeadingBlockCfgs {
	customClasses: string | null;
	hasContainer: cfgsHasContainer;
	size: cfgsSize;
	style: cfgsStyle;
	tag: cfgsTag;
}

interface IHeadingBlockValues {
	content: string
}

type IHeadingBlockProps = Omit<IBlockDefaultProps, 'values' | 'cfgs'> & {
	values: IHeadingBlockValues;
	cfgs: IHeadingBlockCfgs;
};

const props = defineProps<IHeadingBlockProps>();

const sanitizedContent = computed(() => {
  return (props.values.content || '').replace(/<\/?p[^>]*>/gi, '');
});
const cfgsSizeClasses: any = {
  'uk-h1': 'h1',
  'uk-h2': 'h2',
  'uk-h3': 'h3',
  'uk-h4': 'h4',
  'uk-h5': 'h5',
  'uk-h6': 'h6'
};

const getClasses = computed(() => {
  const classes: string[] = [];

  const size = cfgsSizeClasses[props.cfgs.size] || '';

  classes.push(size, props.cfgs.style, (props.cfgs?.customClasses || ''));

  return classes.join(' ');
});
</script>

<style lang="scss">

</style>
